export default __webpack_public_path__ + "static/media/home_4.37b9b719.svg";